import auth from "./auth";
import shuffle from "./shuffle";

export default {
  auth,
  shuffle
};
